import { HelmetProvider, Helmet } from "react-helmet-async";
import { Route, Routes } from "react-router-dom";
import RequireAuth from "./components/auth/RequireAuth";
import "./i18n";

// Layouts
import AuthLayout from "./layouts/Auth";
import DashboardLayout from "./layouts/Dashboard";
import AdminLayout from "./layouts/Admin";
import Page404 from "./pages/auth/Page404";
import Dashboard from "./pages/dashboard";
import CompaniesList from "./pages/pages/CompaniesList";
import CompanyCreate from "./components/clients/CompanyCreate";
import CompanyDetails from "./components/clients/CompanyDetails";
import CompanyEdit from "./components/clients/CompanyEdit";
import SignInPage from "./pages/auth/SignInPage";
import SignIn from "./components/auth/SignIn";
import React from "react";
import AzureAuthError from "./pages/auth/AzureAuthError";
import AdminDashboard from "./pages/admin";
import LoginRedirect from "./components/auth/LoginRedirect";
import PersistLogin from "./components/auth/PersistLogin";
// import AdminDashboard from './pages/admin';


const App = () => {

  return (
    <HelmetProvider>
      <Helmet
        titleTemplate="%s | MEFSC Capability Portal"
        defaultTitle="MEFSC Capability Interface"
      />
      <Routes>

        <Route element={<PersistLogin />}>
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Dashboard />} />
            <Route path='companies' element={<CompaniesList admin={false} />} />
            <Route path="companies/company/:companyId" element={<CompanyDetails admin={false} />} />
          </Route>

          <Route element={<RequireAuth />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path='companies' element={<CompaniesList admin={true} />} />
              <Route path='companies/create' element={<CompanyCreate />} />
              <Route path='companies/company/:companyId' element={<CompanyDetails admin={true} />} />
              <Route path="companies/company/:companyId/edit" element={<CompanyEdit />} />
            </Route>
          </Route>


          <Route path="*" element={<AuthLayout />}>
            <Route path="*" element={<Page404 />} />
            <Route path="oauth/error" element={<AzureAuthError />} />
            <Route path="login" element={<SignInPage children={<SignIn />} />} />
            <Route path="oauth/redirect" element={<LoginRedirect />} />
          </Route>
        </Route>
      </Routes>
    </HelmetProvider >
  );
};

export default App;
